import { useEffect, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuthStore } from "../hooks";
import { Loading } from "../ui";

export const MagicLoginPage = () => {
  // Datos del hook ----------------------------------------//
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {
    // Props
    isLoading,

    // Methods
    startMagicLogin,
  } = useAuthStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const handleMagicLogin = useCallback(async () => {
    const encryptedKey = searchParams.get("key");

    if (!encryptedKey) {
      navigate("/auth/login");
      return;
    }

    await startMagicLogin(encryptedKey);
  }, [searchParams, navigate, startMagicLogin]);

  // Efectos -----------------------------------------------//
  useEffect(() => {
    handleMagicLogin();
  }, [handleMagicLogin]);

  if (isLoading) {
    return <Loading />;
  }

  return null;
};
